import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 2,
	viewBox: "0 0 7 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.10125 1.76V0.0599996H6.68125V1.76H0.10125Z",
		fill: "white"
	})
});
export { SvgMinus as ReactComponent };
